module.exports = __webpack_public_path__ + "static/footerPrefaceLeft-54025c47ec8aa568f4c5b75882504473.jpg";